export default __webpack_public_path__ + "image-upload.asset.8ce7ffd3768a95872ad55f0ad4cf3b4f.svg";